import { motion } from 'framer-motion';
import { LIFESTYLE as DATA, LANDSCAPES } from '../../data/content';
import { LIFESTYLE } from '../../constants/testIds';

export const Lifestyle = () => {
  return (
    <section
      id="landscapes"
      data-testid={LIFESTYLE.root}
      className="relative bg-[#F5F1E8] py-24 lg:py-32"
    >
      <div className="px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto">
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          {/* Big image - tall */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-7 relative overflow-hidden"
          >
            <img
              src={DATA[0].image}
              alt={DATA[0].title}
              className="w-full aspect-[4/5] md:aspect-[5/6] object-cover"
            />
            <div className="absolute bottom-0 inset-x-0 p-6 lg:p-8 bg-gradient-to-t from-[#18342A]/85 to-transparent">
              <span className="text-[10px] tracking-[0.4em] uppercase text-[#C9A458]">
                Lifestyle 01
              </span>
              <h3 className="font-serif text-[#F5F1E8] text-3xl md:text-4xl lg:text-5xl mt-3 leading-tight font-light">
                {DATA[0].title}
              </h3>
            </div>
          </motion.div>

          {/* Right column */}
          <div className="col-span-12 md:col-span-5 flex flex-col gap-6 lg:gap-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#A66B45] text-[#F5F1E8] p-8 lg:p-10 flex flex-col justify-between min-h-[260px]"
            >
              <span className="text-[10px] tracking-[0.4em] uppercase text-[#F5F1E8]/80">
                The Aravi Way
              </span>
              <p className="font-serif text-2xl md:text-3xl lg:text-4xl leading-snug font-light">
                Mornings unhurried.
                <br />
                Evenings unplugged.
                <br />
                A rhythm the city forgot.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="relative overflow-hidden"
            >
              <img
                src={DATA[1].image}
                alt={DATA[1].title}
                className="w-full aspect-[5/4] object-cover"
              />
              <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-[#18342A]/85 to-transparent">
                <span className="text-[10px] tracking-[0.4em] uppercase text-[#C9A458]">
                  Lifestyle 02
                </span>
                <h3 className="font-serif text-[#F5F1E8] text-2xl md:text-3xl mt-2 leading-tight font-light">
                  {DATA[1].title}
                </h3>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Amenities marquee */}
        <div className="mt-24 lg:mt-32">
          <div className="hairline w-full mb-10" />
          <div className="flex items-baseline justify-between mb-8">
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#A66B45]">
              The Living Amenities
            </span>
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#6D6A61]">
              {LANDSCAPES.length} of 40+
            </span>
          </div>
          <div className="overflow-hidden">
            <div className="marquee flex gap-16 whitespace-nowrap">
              {[...LANDSCAPES, ...LANDSCAPES].map((l, i) => (
                <span
                  key={`${l}-${i}`}
                  className="font-serif text-[#18342A] text-5xl md:text-6xl lg:text-7xl font-light"
                >
                  {l}
                  <span className="ml-16 text-[#C9A458]">·</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lifestyle;
